import { forwardRef, useImperativeHandle } from 'react';
import styled from '@emotion/styled';

import { Text, tokens, Icon } from '@hotjar/hotsauce';
import { useSlackForwardingSettings } from '@hotjar/integrations';
import { useTranslation } from '@hotjar/translations';

const StyledIcon = styled.span`
  flex-shrink: 1;
  margin-right: ${tokens.spacer.x1};
`;

const StyledItemText = styled.span`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
`;
interface ForwardToSlackProps {
  siteId: number;
  segmentId: number;
}

export const ForwardToSlackStatusBadge = forwardRef<{ reload: () => void }, ForwardToSlackProps>(
  ({ siteId, segmentId }: ForwardToSlackProps, ref): JSX.Element => {
    const { t } = useTranslation('common');
    const [slackForwardingSettings, , reloadSettings] = useSlackForwardingSettings(
      siteId,
      'recording_segment',
      segmentId,
    );
    const { enabled: slackEnabled } = slackForwardingSettings ?? { enabled: false };

    useImperativeHandle(ref, () => {
      return {
        reload() {
          reloadSettings();
        },
      };
    });

    return (
      <>
        <StyledIcon>
          <Icon icon={'slack'} size="m" />
        </StyledIcon>
        <StyledItemText>Slack</StyledItemText>
        {!slackEnabled && (
          <Text textColor="text_disabled" textType="caption">
            {t('recordings.slack-inactive')}
          </Text>
        )}
      </>
    );
  },
);

ForwardToSlackStatusBadge.displayName = 'ForwardToSlackStatusBadge';
